export default "__VITE_ASSET__Dci0Rt3d__"